import { lazy } from 'react';
// Literal imports keep Expo/webpack chunk resolution aligned with the shipping screens.
export const previewScreens = {
  'plan-history': lazy(() => import('../../screens/HistoryScreen')),
  'plan-imported-conversation': lazy(() => import('../../screens/ImportedConversationScreen')),
  'plan-conversation': lazy(() => import('../../screens/ConversationScreen')),
  'account-profile': lazy(() => import('../../screens/ProfileScreen')),
  'account-billing': lazy(() => import('../../screens/BillingScreen')),
  'plan-create': lazy(() => import('../../screens/ProjectCreationTypeformScreen')),
  'plan-voice': lazy(() => import('../../screens/EllieVoiceScreen')),
  'plan-health-records': lazy(() => import('../../screens/FastenScreen')),
  'plan-team': lazy(() => import('../../screens/ContactsScreen')),
  'plan-medications': lazy(() => import('../../screens/MedicationsScreen')),
  'plan-files': lazy(() => import('../../screens/FilesScreen')),
  'plan-notes': lazy(() => import('../../screens/NotesScreen')),
  'account-health-data': lazy(() => import('../../screens/HealthIntegrationScreen')),
  'account-drive': lazy(() => import('../../screens/DriveSettingsScreen')),
  'plan-cadence-session': lazy(() => import('../../screens/ProjectCadenceSessionScreen')),
  'plan-settings': lazy(() => import('../../screens/ProjectSettingsScreen')),
  'plan-delete': lazy(() => import('../../screens/DeletePlanScreen')),
  'plan-google-calendar': lazy(() => import('../../screens/ProjectCalendarSettingsScreen')),
  'plan-apple-calendar': lazy(() => import('../../screens/ProjectAppleCalendarSettingsScreen')),
  'plan-surveys': lazy(() => import('../../screens/ProjectSurveysScreen')),
  'plan-checklist': lazy(() => import('../../screens/PlanTasksScreen')),
  'plan-benefits': lazy(() => import('../../screens/BenefitsScreen')),
  'account-siri': lazy(() => import('../../screens/SiriShortcutsScreen')),
  'account-watch': lazy(() => import('../../screens/WatchSettingsScreen')),
  'plan-vault': lazy(() => import('../../screens/VaultScreen')),
  'plan-features': lazy(() => import('../../screens/PlanFeaturesScreen')),
  'plan-emergency-sos': lazy(() => import('../../screens/EmergencySOSScreen')),
  'plan-inbox': lazy(() => import('../../screens/InboxScreen')),
  'plan-activity': lazy(() => import('../../screens/AgentSuggestionsScreen')),
  'plan-chat-import': lazy(() => import('../../screens/ChatImportScreen')),
  'plan-member-chat': lazy(() => import('../../screens/ProjectMemberChatScreen')),
  'plan-communicate': lazy(() => import('../../screens/CommunicateScreen')),
  'plan-ingestion': lazy(() => import('../../screens/IngestionScreen')),
  'plan-reminders': lazy(() => import('../../screens/RemindersScreen')),
  'plan-timeline': lazy(() => import('../../screens/TimelineScreen')),
  'plan-smart-reminders': lazy(() => import('../../screens/SmartRemindersScreen')),
  'plan-health-alerts': lazy(() => import('../../screens/HealthAlertsScreen')),
  'plan-wellness': lazy(() => import('../../screens/WellnessScreen')),
  'plan-email': lazy(() => import('../../screens/ProjectEmailSettingsScreen')),
  'plan-inbox-setup': lazy(() => import('../../screens/ProjectInboxSetupScreen')),
  'plan-snapshots': lazy(() => import('../../screens/SnapshotsScreen')),
  'plan-diagnoses': lazy(() => import('../../screens/ProjectDiagnosesScreen')),
  'plan-health-profile': lazy(() => import('../../screens/ProjectHealthProfileScreen')),
  'plan-weekly-briefing': lazy(() => import('../../screens/WeeklyBriefingScreen')),
  'plan-knowledge': lazy(() => import('../../screens/ProjectKnowledgeCoverageScreen')),
  'account-settings': lazy(() => import('../../screens/SettingsScreen')),
  'account-chat': lazy(() => import('../../screens/AccountChatScreen')),
  'plan-calendar': lazy(() => import('../../screens/CalendarScreen')),
  'account-accounts': lazy(() => import('../../screens/AccountsScreen')),
  'plan-chat': lazy(() => import('../../screens/ChatScreen')),
};
